import type { ObjectValues } from '@ballerine/common';

export const AdsProvider = {
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  LINKEDIN: 'linkedin',
  TIKTOK: 'tiktok',
  TWITTER: 'twitter',
} as const;

export const AdsProviders = [
  AdsProvider.FACEBOOK,
  AdsProvider.INSTAGRAM,
  AdsProvider.LINKEDIN,
  AdsProvider.TIKTOK,
  AdsProvider.TWITTER,
] as const satisfies ReadonlyArray<ObjectValues<typeof AdsProvider>>;

export const socialMediaNameMap = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  twitter: 'X (Twitter)',
  linkedin: 'LinkedIn',
  tiktok: 'TikTok',
};
